import { navigate } from "gatsby-link";

const generateDynamicRoute = (locationCity: string, locationState: string, path: string) => {
    const cleanCityName = locationCity?.replace(/\s+/g, '-').toLowerCase();
    const cleanStateName = locationState?.replace(/\s+/g, '-').toLowerCase();
    return `/${cleanStateName}/${cleanCityName}/${path}/`
}

const navigateTo = (route: string | "", lastPoint: string, action: string | null, data: any) => {
    const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
    const pathSegments = currentPath.split('/');
    const basePath = pathSegments.slice(0, pathSegments.indexOf(lastPoint) + 1).join('/');
    if (action === 'navigate') {
        navigate(`${basePath}/${route}`, { state: data });
    }
    return (`${basePath}/${route}`);
}

export { generateDynamicRoute, navigateTo }